export const PREVENT_AUTOFOCUS_KEY = '__gh__react-core-preventAutofocus'
